/**
 * User: Shad
 * Date: 9/11/13
 */
"use strict";

var Backbone = require('dibs-backbone');
var _ = require('underscore');
var $ = require('dibs-jquery-shim');
var endpoints = require('dibs-endpoints');
var SoaModel = require('bunsen/models/SoaModel');
var SoaCollection = require('bunsen/collections/SoaCollection');
var CurrencyConversionRate = require('bunsen/models/ecomm/CurrencyConversionRate');
var CurrencyConversion = require('bunsen/models/ecomm/CurrencyConversion');

var ConversionCalculation = SoaModel.extend();
_.extend(ConversionCalculation.prototype, {

    defaults: {
        conversions: []
    },

    url: endpoints.currencyConversion(),

    relations: function () {
        return [
            {
                type: Backbone.Many,
                key: 'rates',
                relatedModel: CurrencyConversionRate,
                collectionType: SoaCollection
            },
            {
                type: Backbone.Many,
                key: 'conversions',
                relatedModel: CurrencyConversion,
                collectionType: SoaCollection
            }
        ];
    },

    parse: function (data) {
        return (!data.result) ? data : data.result;
    },

    /**
     * Get a model by its label value
     * @param {string} label The label to search for
     * @returns {object}
     */
    getModelByLabel: function (label) {
        return this.get('conversions').findWhere({
            label: label
        });
    },

    /**
     * Get a model and delete by its label value
     * @param {string} label The label to search for
     */
    deleteModelByLabel: function (label) {
        var model = this.getModelByLabel(label);
        if (model) {
            this.get('conversions').remove(model);
        }
    },

    /**
     * Add a price amount to be converted.  Usually, the amount would be
     * in a localized format (EUR, PND/GBP), but can be in USD
     * @param {string} label
     * @param {string} fromAmount
     * @param {string} fromCurrency
     * @returns {ConversionCalculation} for chaining
     */
    addAmount: function (label, fromAmount, fromCurrency) {
        // always delete model before adding to make sure
        // multiple models with the same label do not get added
        this.deleteModelByLabel(label);
        var conversion = new CurrencyConversion({
            fromAmount: fromAmount,
            fromCurrency: fromCurrency,
            label: label,
            toCurrency: null
        });
        this.get('conversions').add(conversion);

        return this;
    },

    /**
     * Look up a converted value based on the label and currency passed in
     * @param {string} label The model to search for
     * @param {string} currency The currency to use for the lookup
     * @returns {*}
     */
    getAmount: function (label, currency) {
        var model = this.getModelByLabel(label);
        if (model) {
            if (model.get('fromCurrency') === currency) {
                return model.get('fromAmount');
            } else if (model.get('toCurrency') === currency) {
                return model.get('toAmount');
            }
        }
        return null;
    },

    /**
     * Update an existing model
     * @param {string} label The model to search for
     * @param {number} amount The amount to update with
     * @param {string} currency The currency the amount is in
     * @param {string} [toOrFrom] Which direction the conversion should go - "to" or "from"
     */
    updateAmount: function (label, amount, currency, toOrFrom) {
        var model = this.getModelByLabel(label);
        var props = {};
        toOrFrom = toOrFrom || 'to';
        props[toOrFrom + 'Amount'] = amount;
        props[toOrFrom + 'Currency'] = currency;

        model.set(props);
    },

    /**
     * Convert all the models against the url endpoint (currency conversion service)
     * @param {string} toCurrency The currency to convert to (USD, PND, EUR)
     * @param {object} [options]
     * @returns {object} The object is a promise
     */
    convertTo: function (toCurrency, options) {
        var self = this;
        // removes models that have a toAmount and where
        // the toCurrency matches the model's currency
        // this is to avoid double conversions
        // they get added back on the model after the save
        var toRemove = [];
        var tmpConversion;
        var originalModel;
        var conversions = this.get('conversions');
        var dfd = new $.Deferred();
        this.get('conversions').each(function (model) {
            var modelCurrency = model.get('toCurrency');
            var modelToAmount = model.get('toAmount');
            if (toCurrency !== modelCurrency && !modelToAmount) {
                model.set('toCurrency', toCurrency);
            } else {
                toRemove.push(model);
            }
        }, this);

        // Make a new conversion to make sure we don't mutate the existing object.
        // Work around for checkout currency localization architechture to avoid
        // corrupting this model when invoking this function multiple times.
        originalModel = this.toJSON();
        tmpConversion = new ConversionCalculation(originalModel);
        tmpConversion.set('conversions', conversions.without.apply(conversions, toRemove));

        // Cancel all outstanding requests to avoid issues with out of order responses
        if (this.convertToDfd) {
            this.convertToDfd.reject();
        }
        this.convertToDfd = dfd;
        tmpConversion.save(null, options)
            .done(function () {
                // Restore to what it was when convertTo was invoked in case it was changed
                // by another call to this function.
                self.set(originalModel);
                // tmpConversion has the models that have been converted.
                // Add them back onto our model now.
                tmpConversion.get('conversions').each(function (newModel) {
                    var model = self.getModelByLabel(newModel.get('label'));
                    model.set(newModel.toJSON());
                });
                self.get('conversions').set(conversions.toJSON());
                dfd.resolve.apply(dfd, arguments);
            })
            .fail(dfd.reject);
        return dfd.promise();
    },
    // Will not need to do this after BE releases full currency conversion
    getAllRates: function () {
        this.get('conversions').reset([
            new CurrencyConversion({
                fromAmount: 1,
                fromCurrency: 'PND',
                label: 'PND',
                toCurrency: 'USD'
            }),
            new CurrencyConversion({
                fromAmount: 1,
                fromCurrency: 'EUR',
                label: 'EUR',
                toCurrency: 'USD'
            }),
            new CurrencyConversion({
                fromAmount: 1,
                fromCurrency: 'USD',
                label: 'USD',
                toCurrency: 'USD'
            })
        ]);
        return this.save();
    }
});

module.exports = ConversionCalculation;


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/ConversionCalculation.js
// module id = 1464
// module chunks = 64